import { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Grid,
  TextField,
} from "@mui/material";

export const CreateCityDialog = ({
  open,
  onClose,
  saving,
  onSave,
  zoneId,
  errors = {},
}) => {
  const [city, setCity] = useState({ name: "", code: "", zone_id: "" });

  useEffect(() => {
    if (open) {
      setCity({ name: "", code: "", zone_id: zoneId });
    }
  }, [open, zoneId]);

  const handleChange = (e) => {
    setCity({ ...city, [e.target.name]: e.target.value });
  };

  const submit = () => {
    onSave(city);
  };

  return (
    <Dialog
      open={open}
      onClose={!saving ? onClose : undefined}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>Create New City</DialogTitle>
      <DialogContent>
        <Grid container spacing={2} sx={{ mt: 1 }}>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="City Name"
              name="name"
              value={city.name}
              onChange={handleChange}
              disabled={saving}
              error={!!errors.name}
              helperText={errors.name?.[0]}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="City Code (Unique)"
              name="code"
              value={city.code}
              onChange={handleChange}
              disabled={saving}
              error={!!errors.code}
              helperText={errors.code?.[0]}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={saving}>
          Cancel
        </Button>
        <Button onClick={submit} variant="contained" disabled={saving}>
          {saving ? "Creating..." : "Create"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
